import React from 'react'

import { t } from 'src/lib/i18n-react'

import ActivityWrapupSkeleton from './ActivityWrapupSkeleton'

const ActivityWrapupConcept = (rest) => {
  return <ActivityWrapupSkeleton titleSection={t('You finished')} {...rest} />
}

export default ActivityWrapupConcept
